import constants from "safervpn-storybook/src/data/constants.json";
import * as actions from "./networksBeaconsGetActions";
import { APPLICATIONS_POST_REQUEST_SUCCESS } from "store/api/organization/applicationsPost/applicationsPostActions";
import { APPLICATIONS_DELETE_REQUEST_SUCCESS } from "store/api/organization/applicationsDelete/applicationsDeleteActions";
import { NETWORKS_POST_REQUEST_SUCCESS } from "store/api/organization/networksPost/networksPostActions";
import { NETWORK_DELETE_REQUEST_SUCCESS } from "store/api/organization/networkDelete/networkDeleteActions";
import { NETWORK_REGIONS_PUT_REQUEST_SUCCESS } from "store/api/organization/networkRegionsPut/networkRegionsPutActions";
import { NETWORK_REGION_DELETE_REQUEST_SUCCESS } from "store/api/organization/networkRegionDelete/networkRegionDeleteActions";
import { NETWORK_INSTANCES_PUT_REQUEST_SUCCESS } from "store/api/organization/networkInstancesPut/networkInstancesPutActions";
import { NETWORK_SCALEUNITS_INCREASE_PUT_REQUEST_SUCCESS } from "store/api/organization/scaleUnitsIncreasePut/scaleUnitsIncreasePutActions";
import { NETWORK_INSTANCE_CHANGE_STATE_REQUEST_SUCCESS } from "store/api/organization/networkInstanceChangeState/networkInstanceChangeStateActions";
import { NETWORK_REGION_CHANGE_STATE_REQUEST_SUCCESS } from "store/api/organization/networkRegionChangeState/networkRegionChangeStateActions";
import { NETWORK_INSTANCE_DELETE_REQUEST_SUCCESS } from "store/api/organization/networkInstanceDelete/networkInstanceDeleteActions";
import { NETWORK_TUNNELS_POST_REQUEST_SUCCESS } from "store/api/organization/networkTunnelsPost/networkTunnelsPostActions";
import { NETWORK_TUNNELS_PUT_REQUEST_SUCCESS } from "store/api/organization/networkTunnelsPut/networkTunnelsPutActions";
import { NETWORK_TUNNELS_DELETE_REQUEST_SUCCESS } from "store/api/organization/networkTunnelsDelete/networkTunnelsDeleteActions";
import { NETWORK_HA_TUNNELS_POST_REQUEST_SUCCESS } from "store/api/organization/networkHATunnelsPost/networkHATunnelsPostActions";
import { NETWORK_HA_TUNNELS_PUT_REQUEST_SUCCESS } from "store/api/organization/networkHATunnelsPut/networkHATunnelsPutActions";
import { NETWORK_HA_TUNNELS_DELETE_REQUEST_SUCCESS } from "store/api/organization/networkHATunnelsDelete/networkHATunnelsDeleteActions";
import { NETWORK_BEACON_DELETE_REQUEST_SUCCESS } from "@p81-common/shell-core-js/dist/redux/networkBeaconDelete";
import { NETWORK_ROUTES_POST_REQUEST_SUCCESS } from "store/api/organization/networkRoutesPost/networkRoutesPostActions";
import { NETWORK_POLICIES_POST_REQUEST_SUCCESS } from "store/api/organization/networkPoliciesPost/networkPoliciesPostActions";
import { CURRENT_CHILD_ORGANIZATION_SET } from "store/domain/currentChildOrganization/currentChildOrganizationActions";
// Inlined — these 3 slices are now MFE-owned (deleted from host).
// networksBeaconsGet still listens for their *_SUCCESS dispatches to clear beacon state.
const NETWORK_CUSTOM_DNS_PUT_REQUEST_SUCCESS = "NETWORK_CUSTOM_DNS_PUT_REQUEST_SUCCESS";
const NETWORK_SPLIT_TUNNELING_PUT_REQUEST_SUCCESS = "NETWORK_SPLIT_TUNNELING_PUT_REQUEST_SUCCESS";
const URL_FILTERING_PUT_REQUEST_SUCCESS = "URL_FILTERING_PUT_REQUEST_SUCCESS";

function insertOrUpdateBeacon(state, action) {
  let beacons = state.data?.networkBeacons || [];
  let beacon = action.data?.networkBeacon;

  if (state.tenantId !== beacon?.tenantId) {
    return state;
  }

  let existingBeacon = beacons.find(({ id }) => id === beacon.id);

  if (existingBeacon?.status === constants.networkBeaconStatus.FAILED) {
    return state;
  }

  let newBeacons = beacons.some(({ id }) => id === beacon.id)
    ? beacons.map((nestedBeacon) =>
        nestedBeacon.id === beacon.id ? beacon : nestedBeacon
      )
    : [...beacons, beacon];

  return {
    ...state,
    data: {
      ...state.data,
      networkBeacons: newBeacons,
    },
  };
}

function removeBeacon(state, action) {
  let beacons = state.data?.networkBeacons || [];
  let beacon = action.data?.networkBeacon;

  return {
    ...state,
    data: {
      ...state.data,
      networkBeacons: beacons.filter(({ id }) => id !== beacon?.id),
    },
  };
}

// Wrapper that also increments tunnelEventVersion for bandwidth refresh
function removeBeaconAndIncrementTunnelVersion(state, action) {
  const newState = removeBeacon(state, action);
  return {
    ...newState,
    data: {
      ...newState.data,
      tunnelEventVersion: (state.data?.tunnelEventVersion ?? 0) + 1,
    },
  };
}

function removeAllBeacons(state) {
  return {
    ...state,
    data: {
      ...state.data,
      networkBeacons: [],
    },
  };
}

function insertBeaconFromHTTPResponse(state, action) {
  let beacons = state.data?.networkBeacons || [];
  let beacon = action.data?.networkBeacon;

  if (state.tenantId !== beacon?.tenantId) {
    return state;
  }

  return {
    ...state,
    data: {
      ...state.data,
      networkBeacons: [...beacons, beacon],
    },
  };
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [actions.NETWORKS_BEACONS_GET_REQUEST]: (state, action) => ({
    ...state,
    loading: true,
    loaded: false,
    error: null,
    data: state.data,
    tenantId: null,
  }),

  [actions.NETWORKS_BEACONS_GET_REQUEST_SUCCESS]: (state, action) => ({
    ...state,
    loading: false,
    loaded: true,
    error: null,
    data: action.data,
    tenantId: action.tenantId,
  }),

  [actions.NETWORKS_BEACONS_GET_REQUEST_FAILURE]: (state, action) => ({
    ...state,
    loading: false,
    loaded: false,
    error: action.error,
    data: null,
    tenantId: null,
  }),

  [actions.SOCKET_EVENT_DEPLOY_START]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_DEPLOY_STATUS]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_DEPLOY_SUCCESS]: removeBeacon,
  [actions.SOCKET_EVENT_DEPLOY_FAILED]: insertOrUpdateBeacon,

  [actions.SOCKET_EVENT_DEPLOY_CUSTOM_START]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_DEPLOY_CUSTOM_STATUS]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_DEPLOY_CUSTOM_SUCCESS]: removeBeacon,
  [actions.SOCKET_EVENT_DEPLOY_CUSTOM_FAILED]: insertOrUpdateBeacon,

  [actions.SOCKET_EVENT_DESTROY_START]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_DESTROY_STATUS]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_DESTROY_SUCCESS]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_DESTROY_FAILED]: insertOrUpdateBeacon,

  [actions.SOCKET_EVENT_ROUTETABLE_UPDATE_START]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_ROUTETABLE_UPDATE_STATUS]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_ROUTETABLE_UPDATE_SUCCESS]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_ROUTETABLE_UPDATE_FAILED]: insertOrUpdateBeacon,

  [actions.SOCKET_EVENT_LOCATION_ADD_START]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_LOCATION_ADD_STATUS]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_LOCATION_ADD_SUCCESS]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_LOCATION_ADD_FAILED]: insertOrUpdateBeacon,

  [actions.SOCKET_EVENT_LOCATION_CUSTOM_ADD_START]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_LOCATION_CUSTOM_ADD_STATUS]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_LOCATION_CUSTOM_ADD_SUCCESS]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_LOCATION_CUSTOM_ADD_FAILED]: insertOrUpdateBeacon,

  [actions.SOCKET_EVENT_LOCATION_REMOVE_START]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_LOCATION_REMOVE_STATUS]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_LOCATION_REMOVE_SUCCESS]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_LOCATION_REMOVE_FAILED]: insertOrUpdateBeacon,

  [actions.SOCKET_EVENT_SCALEUNIT_INCREASE_START]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_SCALEUNIT_INCREASE_STATUS]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_SCALEUNIT_INCREASE_SUCCESS]: removeBeacon,
  [actions.SOCKET_EVENT_SCALEUNIT_INCREASE_FAILED]: insertOrUpdateBeacon,

  [actions.SOCKET_EVENT_SCALEUNIT_REDUCE_START]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_SCALEUNIT_REDUCE_STATUS]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_SCALEUNIT_REDUCE_SUCCESS]: removeBeacon,
  [actions.SOCKET_EVENT_SCALEUNIT_REDUCE_FAILED]: insertOrUpdateBeacon,

  [actions.SOCKET_EVENT_REGION_CHANGE_STATE_START]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_REGION_CHANGE_STATE_STATUS]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_REGION_CHANGE_STATE_SUCCESS]: removeBeacon,
  [actions.SOCKET_EVENT_REGION_CHANGE_STATE_FAILED]: insertOrUpdateBeacon,

  [actions.SOCKET_EVENT_NODE_ADD_START]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_NODE_ADD_STATUS]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_NODE_ADD_SUCCESS]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_NODE_ADD_FAILED]: insertOrUpdateBeacon,

  [actions.SOCKET_EVENT_NODE_CUSTOM_ADD_START]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_NODE_CUSTOM_ADD_STATUS]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_NODE_CUSTOM_ADD_SUCCESS]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_NODE_CUSTOM_ADD_FAILED]: insertOrUpdateBeacon,

  [actions.SOCKET_EVENT_NODE_REMOVE_START]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_NODE_REMOVE_STATUS]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_NODE_REMOVE_SUCCESS]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_NODE_REMOVE_FAILED]: insertOrUpdateBeacon,

  [actions.SOCKET_EVENT_NODE_CHANGE_STATE_START]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_NODE_CHANGE_STATE_STATUS]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_NODE_CHANGE_STATE_SUCCESS]: removeBeacon,
  [actions.SOCKET_EVENT_NODE_CHANGE_STATE_FAILED]: insertOrUpdateBeacon,

  [actions.SOCKET_EVENT_TUNNEL_ADD_START]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_TUNNEL_ADD_STATUS]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_TUNNEL_ADD_SUCCESS]: removeBeaconAndIncrementTunnelVersion,
  [actions.SOCKET_EVENT_TUNNEL_ADD_FAILED]: insertOrUpdateBeacon,

  [actions.SOCKET_EVENT_TUNNEL_UPDATE_START]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_TUNNEL_UPDATE_STATUS]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_TUNNEL_UPDATE_SUCCESS]: removeBeaconAndIncrementTunnelVersion,
  [actions.SOCKET_EVENT_TUNNEL_UPDATE_FAILED]: insertOrUpdateBeacon,

  [actions.SOCKET_EVENT_TUNNEL_REMOVE_START]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_TUNNEL_REMOVE_STATUS]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_TUNNEL_REMOVE_SUCCESS]: removeBeaconAndIncrementTunnelVersion,
  [actions.SOCKET_EVENT_TUNNEL_REMOVE_FAILED]: insertOrUpdateBeacon,

  [actions.SOCKET_EVENT_TUNNEL_HA_ADD_START]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_TUNNEL_HA_ADD_STATUS]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_TUNNEL_HA_ADD_SUCCESS]: removeBeaconAndIncrementTunnelVersion,
  [actions.SOCKET_EVENT_TUNNEL_HA_ADD_FAILED]: insertOrUpdateBeacon,

  [actions.SOCKET_EVENT_TUNNEL_HA_UPDATE_START]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_TUNNEL_HA_UPDATE_STATUS]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_TUNNEL_HA_UPDATE_SUCCESS]: removeBeaconAndIncrementTunnelVersion,
  [actions.SOCKET_EVENT_TUNNEL_HA_UPDATE_FAILED]: insertOrUpdateBeacon,

  [actions.SOCKET_EVENT_TUNNEL_HA_REMOVE_START]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_TUNNEL_HA_REMOVE_STATUS]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_TUNNEL_HA_REMOVE_SUCCESS]: removeBeaconAndIncrementTunnelVersion,
  [actions.SOCKET_EVENT_TUNNEL_HA_REMOVE_FAILED]: insertOrUpdateBeacon,

  [actions.SOCKET_EVENT_SPLITTUNNELING_UPDATE_START]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_SPLITTUNNELING_UPDATE_STATUS]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_SPLITTUNNELING_UPDATE_SUCCESS]: removeBeacon,
  [actions.SOCKET_EVENT_SPLITTUNNELING_UPDATE_FAILED]: insertOrUpdateBeacon,

  [actions.SOCKET_EVENT_CUSTOMDNS_UPDATE_START]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_CUSTOMDNS_UPDATE_STATUS]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_CUSTOMDNS_UPDATE_SUCCESS]: removeBeacon,
  [actions.SOCKET_EVENT_CUSTOMDNS_UPDATE_FAILED]: insertOrUpdateBeacon,

  [APPLICATIONS_POST_REQUEST_SUCCESS]: insertBeaconFromHTTPResponse,
  [APPLICATIONS_DELETE_REQUEST_SUCCESS]: insertBeaconFromHTTPResponse,
  [NETWORKS_POST_REQUEST_SUCCESS]: insertOrUpdateBeacon,
  [NETWORK_DELETE_REQUEST_SUCCESS]: insertOrUpdateBeacon,
  [NETWORK_REGIONS_PUT_REQUEST_SUCCESS]: insertOrUpdateBeacon,
  [NETWORK_REGION_DELETE_REQUEST_SUCCESS]: insertOrUpdateBeacon,
  [NETWORK_INSTANCES_PUT_REQUEST_SUCCESS]: insertOrUpdateBeacon,
  [NETWORK_SCALEUNITS_INCREASE_PUT_REQUEST_SUCCESS]: insertOrUpdateBeacon,
  [NETWORK_INSTANCE_DELETE_REQUEST_SUCCESS]: insertOrUpdateBeacon,
  [NETWORK_INSTANCE_CHANGE_STATE_REQUEST_SUCCESS]: insertOrUpdateBeacon,
  [NETWORK_REGION_CHANGE_STATE_REQUEST_SUCCESS]: insertOrUpdateBeacon,
  [NETWORK_ROUTES_POST_REQUEST_SUCCESS]: insertOrUpdateBeacon,
  [NETWORK_TUNNELS_POST_REQUEST_SUCCESS]: insertOrUpdateBeacon,
  [NETWORK_TUNNELS_PUT_REQUEST_SUCCESS]: insertOrUpdateBeacon,
  [NETWORK_TUNNELS_DELETE_REQUEST_SUCCESS]: insertOrUpdateBeacon,
  [NETWORK_HA_TUNNELS_POST_REQUEST_SUCCESS]: insertOrUpdateBeacon,
  [NETWORK_HA_TUNNELS_PUT_REQUEST_SUCCESS]: insertOrUpdateBeacon,
  [NETWORK_HA_TUNNELS_DELETE_REQUEST_SUCCESS]: insertOrUpdateBeacon,
  [NETWORK_POLICIES_POST_REQUEST_SUCCESS]: insertOrUpdateBeacon,

  [actions.SOCKET_EVENT_APPLICATION_ADD_START]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_APPLICATION_ADD_STATUS]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_APPLICATION_ADD_SUCCESS]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_APPLICATION_ADD_FAILED]: insertOrUpdateBeacon,

  [actions.SOCKET_EVENT_APPLICATION_REMOVE_START]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_APPLICATION_REMOVE_STATUS]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_APPLICATION_REMOVE_SUCCESS]: removeAllBeacons,
  [actions.SOCKET_EVENT_APPLICATION_REMOVE_FAILED]: insertOrUpdateBeacon,

  [actions.SOCKET_EVENT_APPLICATION_UPDATE_START]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_APPLICATION_UPDATE_STATUS]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_APPLICATION_UPDATE_SUCCESS]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_APPLICATION_UPDATE_FAILED]: insertOrUpdateBeacon,

  [actions.SOCKET_EVENT_NETFILTER_UPDATE_START]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_NETFILTER_UPDATE_STATUS]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_NETFILTER_UPDATE_SUCCESS]: removeBeacon,
  [actions.SOCKET_EVENT_NETFILTER_UPDATE_FAILED]: insertOrUpdateBeacon,

  [actions.SOCKET_EVENT_ENABLE_FIREWALL_LOGS_START]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_ENABLE_FIREWALL_LOGS_STATUS]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_ENABLE_FIREWALL_LOGS_SUCCESS]: removeBeacon,
  [actions.SOCKET_EVENT_ENABLE_FIREWALL_LOGS_FAILED]: insertOrUpdateBeacon,

  [actions.SOCKET_EVENT_DNSFILTERING_UPDATE_START]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_DNSFILTERING_UPDATE_STATUS]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_DNSFILTERING_UPDATE_SUCCESS]: removeBeacon,
  [actions.SOCKET_EVENT_DNSFILTERING_UPDATE_FAILED]: insertOrUpdateBeacon,

  [actions.SOCKET_EVENT_DNSFILTERING_REMOVE_START]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_DNSFILTERING_REMOVE_STATUS]: insertOrUpdateBeacon,
  [actions.SOCKET_EVENT_DNSFILTERING_REMOVE_SUCCESS]: removeBeacon,
  [actions.SOCKET_EVENT_DNSFILTERING_REMOVE_FAILED]: insertOrUpdateBeacon,

  [NETWORK_CUSTOM_DNS_PUT_REQUEST_SUCCESS]: insertOrUpdateBeacon,
  [NETWORK_SPLIT_TUNNELING_PUT_REQUEST_SUCCESS]: insertOrUpdateBeacon,
  [URL_FILTERING_PUT_REQUEST_SUCCESS]: insertOrUpdateBeacon,

  [NETWORK_BEACON_DELETE_REQUEST_SUCCESS]: (state, action) => ({
    ...state,
    data: {
      ...state.data,
      networkBeacons: (state.data.networkBeacons || []).filter(
        ({ id }) => id !== action.payload.beaconId
      ),
    },
  }),

  [CURRENT_CHILD_ORGANIZATION_SET]: () => ({ ...initialState }),
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  loaded: false,
  loading: false,
  error: null,
  data: null,
  tenantId: null,
};

export default function networksBeaconsGetReducer(
  state = initialState,
  action
) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
